import React from 'react';
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tabs,
    Tab,
    Typography,

} from "@material-ui/core";
import useStyles from '../styles/styles';
import {Prism as SyntaxHighlighter} from 'react-syntax-highlighter';
import {base16AteliersulphurpoolLight} from 'react-syntax-highlighter/dist/esm/styles/prism';


const LenderFeedbackPostingInstructions = () => {
    const classes = useStyles();
    const [apiTab, setApiTab] = React.useState(0);
    const [value, setValue] = React.useState(0);
    const [codeTab, setCodeTab] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleCodeTab = (event, newValue) => {
        setCodeTab(newValue);
    };

    const handleApiTab = (event, newValue) => {
        setApiTab(newValue);
    };

    const servicerIdFromParams = (new URL(window.location)).searchParams.get("servicer_id");

    const servicerIdSet = !!servicerIdFromParams;

    const servicerId = servicerIdSet ? servicerIdFromParams : '<Servicer\'s Identifier>';

    function TabPanel(props) {
        const { children, value, value2, index, ...other } = props;

        return (
            <Typography
                component="div"
                role="tabpanel"
                hidden={value !== index}
                id={`wrapped-tabpanel-${index}`}
                aria-labelledby={`wrapped-tab-${index}`}
                {...other}
            >
                {value === index && <Box p={3} pt={1}>{children}</Box>}
            </Typography>
        );
    }
    function TabPanel2(props) {
        const {children, value, index, ...other} = props;

        return (
            <Typography
                component="div"
                role="tabpanel"
                hidden={value !== index}
                id={`wrapped-tabpanel-${index}`}
                aria-labelledby={`wrapped-tab-${index}`}
                {...other}
            >
                {value === index && <Box p={3} pt={1}>{children}</Box>}
            </Typography>
        );
    }

    return (
        <>
            <Typography variant="h2" gutterBottom>
                Lender Feedback Posting Instructions
            </Typography>
            <Typography variant="body1">
                <p>
                    Acquire Interactive provides lenders with a Lender Feedback API that allows lenders to post loan
                    application details related to the disposition of a loan application after the loan application has
                    been sold to a lender.  To achieve this you will need to post a JSON payload into our REST
                    endpoint.
                </p>

            </Typography>

            <Paper className={`${classes.paper} ${classes.autoWidth}`}>
                <Table className={`${classes.table} ${classes.marginAuto}`}  size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell variant="head">Endpoint</TableCell>
                            <TableCell variant="head">Address</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>Test</TableCell>
                            <TableCell>https://test-api.acquireinteractive.com/lender/feedback</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Production</TableCell>
                            <TableCell>https://api.acquireinteractive.com/lender/feedback</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Paper>

            <Typography variant="body1">
                <p>
                    The API is authenticated using <a href={"https://www.httpwatch.com/httpgallery/authentication/"}>HTTP Basic Authentication</a> over TLS.
                    Your account manager will provide you with a username and password combination for both the test and prod environments.
                    This authentication is identical to the credentials you were issued for the Loan API.

                </p>
                <p>
                    Example: username=david, password=strongpassword -- this combination would yield an authorization header as follows: "Authorization: Basic ZGF2aWQ6c3Ryb25ncGFzc3dvcmQ=".
                    Examples of how to include this header can be seen below in the code "Code Samples".
                </p>
            </Typography>

            <Paper className={classes.paper}>
                <Tabs
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={handleApiTab}
                    centered
                    value={apiTab}>
                    <Tab label="JSON Root"/>
                    <Tab label="LoanApplication"/>
                </Tabs>

                <TabPanel value={apiTab} index={0}>
                    <Table className={classes.table} size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell variant="head">Field&nbsp;Name</TableCell>
                                <TableCell variant="head">Data&nbsp;Type</TableCell>
                                <TableCell variant="head">Required</TableCell>
                                <TableCell variant="head">Example</TableCell>
                                <TableCell variant="head">Notes</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell>servicer_id</TableCell>
                                <TableCell>String</TableCell>
                                <TableCell>Yes</TableCell>
                                <TableCell>{servicerId}</TableCell>
                                <TableCell>Required, the identifier assigned by Acquire
                                    Interactive to a lender</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>loan_applications</TableCell>
                                <TableCell>{`List<LoanApplication>`}</TableCell>
                                <TableCell>Yes</TableCell>
                                <TableCell>{`[ {
                                    "primary_email" : "lenderfeedback@apitest.com",
                                    "application_timestamp" : "2021-02-03T00:50:28.000Z",
                                    "loan_amount" : 500.00,
                                    "loan_disposition" : "LOAN_FUNDED"
                                } ]`}</TableCell>
                                <TableCell>The array of loan application dispositions.</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TabPanel>
                <TabPanel value={apiTab} index={1}>
                    <Table className={classes.table} size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell variant="head">Field&nbsp;Name</TableCell>
                                <TableCell variant="head">Data&nbsp;Type</TableCell>
                                <TableCell variant="head">Required</TableCell>
                                <TableCell variant="head">Example</TableCell>
                                <TableCell variant="head">Notes</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell>primary_email</TableCell>
                                <TableCell>String</TableCell>
                                <TableCell>Yes</TableCell>
                                <TableCell>lenderfeedback@apitest.com</TableCell>
                                <TableCell>Required, the email that is associated to the loan application</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>application_timestamp</TableCell>
                                <TableCell>Date</TableCell>
                                <TableCell>Yes</TableCell>
                                <TableCell>2021-02-03T00:50:28.000Z</TableCell>
                                <TableCell>Required, the timestamp (in UTC) at which the loan application was received</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>loan_amount</TableCell>
                                <TableCell>Decimal</TableCell>
                                <TableCell>No</TableCell>
                                <TableCell>500.00</TableCell>
                                <TableCell>Optional, the loan amount of the loan application, should be provided if disposition is LOAN_FUNDED</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>funded_amount</TableCell>
                                <TableCell>Decimal</TableCell>
                                <TableCell>No</TableCell>
                                <TableCell>500.00</TableCell>
                                <TableCell>Optional, the amount funded for the loan application, should be provided if disposition is LOAN_FUNDED</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>commission</TableCell>
                                <TableCell>Decimal</TableCell>
                                <TableCell>No</TableCell>
                                <TableCell>500.00</TableCell>
                                <TableCell>Optional, the commission amount earned by AI. Should only be provided if commission is paid to AI when a loan is originated.</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>loan_disposition</TableCell>
                                <TableCell>Enum</TableCell>
                                <TableCell>Yes</TableCell>
                                <TableCell>LOAN_FUNDED</TableCell>
                                <TableCell>Required, the disposition of the loan application, one of the following values:<br/>
                                    NO_REDIRECT, NO_CONTACT, BAD_BANK_INFO, FRAUD, RESCINDED_LOAN, NO_LOAN, LOAN_FUNDED, OTHER (case sensitive)
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TabPanel>
            </Paper>

            <Typography variant="h4" align="left">
                JSON Samples
            </Typography>
            <Paper className={classes.paper}>
                <Tabs
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={handleChange}
                    centered
                    value={value}>
                    <Tab label="Input"/>
                    <Tab label="Success"/>
                    <Tab label="Error"/>
                    <Tab label="Fail"/>
                </Tabs>



                <TabPanel2 value={value} index={0}>
                    <SyntaxHighlighter language="php" style={base16AteliersulphurpoolLight}>
{`
{
  "servicer_id" : "` + servicerId + `",
  "loan_applications" : [ {
    "primary_email" : "lenderfeedback@apitest.com",
    "application_timestamp" : "2021-02-03T00:50:28.000Z",
    "loan_amount" : 500.00,
    "loan_disposition" : "LOAN_FUNDED"
  } ]
}
`}
                    </SyntaxHighlighter>
                </TabPanel2>
                <TabPanel2 value={value} index={1}>
                    <SyntaxHighlighter language="javascript" style={base16AteliersulphurpoolLight}>
{`
{
  "request_id" : "65990b7e-cedb-4705-aa3e-ebe9400e5ab0",
  "request_received" : "2021-02-03T19:20:43.265Z",
  "response_rendered" : "2021-02-03T19:20:43.270Z",
  "response_time" : 0.005,
  "status" : "SUCCESS",
  "messages" : null,
  "validation_errors" : null
}
`}
                    </SyntaxHighlighter>
                </TabPanel2>
                <TabPanel2 value={value} index={2}>
                    <SyntaxHighlighter language="javascript" style={base16AteliersulphurpoolLight}>
{`
{
  "request_id" : "cb44ad96-64dd-4b3e-989f-45bdb094663f",
  "request_received" : "2021-02-03T01:13:40.019Z",
  "response_rendered" : "2021-02-03T01:13:40.052Z",
  "response_time" : 0.033,
  "status" : "ERROR",
  "messages" : null,
  "validation_errors" : {
    ".loanApplications[0].loanDisposition" : [ "is required" ]
  }
}                          
`}
                    </SyntaxHighlighter>
                </TabPanel2>
                <TabPanel2 value={value} index={3}>
                    <SyntaxHighlighter language="javascript" style={base16AteliersulphurpoolLight}>
                        {`
{
  "request_id" : "d7d46639-a640-4ca4-a743-44a58d603cb4",
  "request_received" : "2021-02-03T20:36:31.449Z",
  "response_rendered" : "2021-02-03T20:36:31.451Z",
  "response_time" : 0.002,
  "status" : "FAIL",
  "messages" : null,
  "validation_errors" : null
}
`}
                    </SyntaxHighlighter>
                </TabPanel2>
            </Paper>
            <Typography variant="h4" align="left">
                Code Samples
            </Typography>
            <Paper className={classes.paper}>
                <Tabs
                    value={codeTab}
                    onChange={handleCodeTab}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                >
                    <Tab label="PHP"/>
                    <Tab label="Node"/>
                    <Tab label="Java"/>
                    <Tab label="C#"/>
                    <Tab label="Curl"/>
                    <Tab label="Python"/>
                </Tabs>

                <TabPanel value={codeTab} index={0}>
                    <SyntaxHighlighter language="php" style={base16AteliersulphurpoolLight}>
                        {
                            `<?php

$curl = curl_init();

curl_setopt_array($curl, array(
    CURLOPT_URL => "https://test-api.acquireinteractive.com/lender/feedback",
    CURLOPT_RETURNTRANSFER => true,
    CURLOPT_ENCODING => "",
    CURLOPT_MAXREDIRS => 10,
    CURLOPT_TIMEOUT => 0,
    CURLOPT_FOLLOWLOCATION => false,
    CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,
    CURLOPT_CUSTOMREQUEST => "POST",
    CURLOPT_POSTFIELDS => <<<EOT
    {
      "servicer_id": "` + servicerId + `",
      "loan_applications" : [ {
        "primary_email" : "lenderfeedback@apitest.com",
        "application_timestamp" : "2021-02-03T00:50:28.000Z",
        "loan_amount" : 500.00,
        "loan_disposition" : "LOAN_FUNDED"
      } ]
    }
EOT
    ,CURLOPT_HTTPHEADER => array(
        "Content-Type: application/json",
        "Authorization: Basic dGVzdDp0ZXN0"
    ),
));

$response = curl_exec($curl);
$err = curl_error($curl);

curl_close($curl);

if ($err) {
    echo "cURL Error #:" . $err;
} else {
    echo $response;
} ?>
                        `}
                    </SyntaxHighlighter>
                </TabPanel>
                <TabPanel value={codeTab} index={1}>
                    <SyntaxHighlighter language="javascript" style={base16AteliersulphurpoolLight}>
                        {`
var postData =  \`{
 "servicer_id": "${servicerId}",
  "loan_applications" : [ {
    "primary_email" : "lenderfeedback@apitest.com",
    "application_timestamp" : "2021-02-03T00:50:28.000Z",
    "loan_amount" : 500.00,
    "loan_disposition" : "LOAN_FUNDED"
  } ]
}\`;

var https = require('https');

var options = {
    'host': 'test-api.acquireinteractive.com',
    'method': 'POST',
    'path': '/lender/feedback',
    'headers': {
        'Content-Type': 'application/json',
        'Authorization': 'Basic dGVzdDp0ZXN0',
        'Content-Length': postData.length
    }
};

var req = https.request(options, function (res) {
    var chunks = [];

    res.on("data", function (chunk) {
        chunks.push(chunk);
    });

    res.on("end", function (chunk) {
        var body = Buffer.concat(chunks);
        console.log(body.toString());
    });

    res.on("error", function (error) {
        console.error(error);
    });
});

req.write(postData);

req.end();
                        `}
                    </SyntaxHighlighter>
                </TabPanel>
                <TabPanel value={codeTab} index={2}>
                    <SyntaxHighlighter language="java" style={base16AteliersulphurpoolLight}>
                        {
                            `/*
* To following code is used to create a POST Web request with appropriate information, so that a response is displayed and received.
* In order to execute the code, create a command line app and place the code in the Main() method and run the application.
*/ 
try {
    URL a = new URL("https://test-api.acquireinteractive.com/lender/feedback");

    HttpURLConnection urlCon = (HttpURLConnection) a.openConnection();

    urlCon.setRequestMethod("POST");

    urlCon.setRequestProperty("Content-Type", "application/json");

    urlCon.setRequestProperty("Authorization", "Basic dGVzdDp0ZXN0");

    urlCon.setDoOutput(true);

    String json = "{\\"servicer_id\\": \\"${servicerId}\\"," +
                      "\\"loan_applications\\" : [ {" +
                      "\\"primary_email\\" : \\"lenderfeedback@apitest.com\\"," +
                      "\\"application_timestamp\\" : \\"2021-02-03T00:50:28.000Z\\"," +
                      "\\"loan_amount\\" : 500.00," +
                      "\\"loan_disposition\\" : \\"LOAN_FUNDED\\"" +
                      "} ]}";

    try (OutputStream os = urlCon.getOutputStream()) {
        byte[] input = json.getBytes("utf-8");
        os.write(input, 0, input.length);
    }

    if (urlCon.getResponseCode() < HttpURLConnection.HTTP_BAD_REQUEST) {
        try (BufferedReader br = new BufferedReader(
            new InputStreamReader(urlCon.getInputStream(), "utf-8"))) {
                StringBuilder response = new StringBuilder();
                String responseLine = null;
                while ((responseLine = br.readLine()) != null) {
                    response.append(responseLine.trim());
                }
                System.out.println(response.toString());
            }
        }
    else {
        try (BufferedReader br = new BufferedReader(
            new InputStreamReader(urlCon.getErrorStream(), "utf-8"))) {
                StringBuilder response = new StringBuilder();
                String responseLine = null;
                while ((responseLine = br.readLine()) != null) {
                    response.append(responseLine.trim());
                }
                System.out.println(response.toString());
            }
        }
    }
catch (MalformedURLException e) {
            e.printStackTrace();
        }
catch (IOException e) {
            e.printStackTrace();
}`}
                    </SyntaxHighlighter>
                </TabPanel>
                <TabPanel value={codeTab} index={3}>
                    <SyntaxHighlighter language="c#" style={base16AteliersulphurpoolLight}>
                        {
                            `/*
* To following code is used to create a POST Web request with appropriate information, so that a response is displayed and received.
* In order to execute the code, create a blank console application and place the code in the Main() method and run the application.
*/ 
Console.WriteLine("\\nCreating Request....");
HttpWebRequest httpWebRequest = (HttpWebRequest)WebRequest.Create("https://test-api.acquireinteractive.com/lender/feedback");
httpWebRequest.ContentType = "application/json";
httpWebRequest.Method = "POST";
httpWebRequest.Headers.Add("Authorization", "Basic dGVzdDp0ZXN0");

using (var streamWriter = new StreamWriter(httpWebRequest.GetRequestStream()))
{
    string json = "{\\"servicer_id\\": \\"${servicerId}\\"," +
                      "\\"loan_applications\\" : [ {" +
                      "\\"primary_email\\" : \\"lenderfeedback@apitest.com\\"," +
                      "\\"application_timestamp\\" : \\"2021-02-03T00:50:28.000Z\\"," +
                      "\\"loan_amount\\" : 500.00," +
                      "\\"loan_disposition\\" : \\"LOAN_FUNDED\\"" +
                      "} ]}";
                                  
    streamWriter.Write(json);

}
Console.WriteLine("\\nRequest Created....");
Console.WriteLine("\\nSending Request....");

try
{
    var httpResponse = (HttpWebResponse)httpWebRequest.GetResponse();

    using (var streamReader = new StreamReader(httpResponse.GetResponseStream()))
    {
        var result = streamReader.ReadToEnd();
        Console.WriteLine("\\nResponse received: " + result);
        Console.ReadLine();
    }
}
catch (WebException e)
{
    using (WebResponse response = e.Response)
    {
        using (Stream data = response.GetResponseStream())
        {
            StreamReader sr = new StreamReader(data);
            Console.WriteLine("\\nErred Response received: " + sr.ReadToEnd());
            Console.ReadLine();
        }
    }
}
   `}
                    </SyntaxHighlighter>
                </TabPanel>
                <TabPanel value={codeTab} index={4}>
                    <SyntaxHighlighter language="bash" style={base16AteliersulphurpoolLight}>
{`
curl --location --request POST "https://test-api.acquireinteractive.com/lender/feedback" \\
    --header "Content-Type: application/json" \\
    --header "Authorization: Basic dGVzdDp0ZXN0" \\
    --data "{
        \\"servicer_id\\": \\"` + servicerId + `\\",
        \\"loan_applications\\" : [ {
            \\"primary_email\\" : \\"lenderfeedback@apitest.com\\",
            \\"application_timestamp\\" : \\"2021-02-03T00:50:28.000Z\\",
            \\"loan_amount\\" : 500.00,
            \\"loan_disposition\\" : \\"LOAN_FUNDED\\"
        } ]
      }"
`}
                    </SyntaxHighlighter>
                </TabPanel>
                <TabPanel value={codeTab} index={5}>
                    <SyntaxHighlighter language="python" style={base16AteliersulphurpoolLight}>
                        {
                            `
import requests

url = "https://test-api.acquireinteractive.com/lender/feedback"
data = {"servicer_id": "${servicerId}",
        "minimum_price": 80.50,
        "source_sub_code_1": "100",
        "home_phone": "5123486640",
        "primary_email": "joe.b.doe@acquireinteractive.com",
        "ssn": 200304000}

headers = {'Content-Type': 'application/json', 'Authorization': 'Basic dGVzdDp0ZXN0'}
try:
    r = requests.post(url, data=data, headers=headers)
    r.raise_for_status()
    print(r.text)
except requests.exceptions.HTTPError as errh:
    print ("Http Error:",errh)
except requests.exceptions.ConnectionError as errc:
    print ("Error Connecting:",errc)
except requests.exceptions.Timeout as errt:
    print ("Timeout Error:",errt)
except requests.exceptions.RequestException as err:
    print ("Oops: Something Else",err)
                            `}
                    </SyntaxHighlighter>
                </TabPanel>
            </Paper>

        </>
    )
}

export default LenderFeedbackPostingInstructions